/** Protocolist identity comes from room state; known service/device IDs support older calls. */
export function isProtocolistIdentity(
  userId?: string,
  identity?: string,
  configuredUserId?: string,
): boolean {
  return Boolean(
    (configuredUserId && userId === configuredUserId) ||
      userId?.startsWith("@service_account:") ||
      identity?.endsWith(":RECORDER_AGENT"),
  );
}
export function protocolistLast<T extends { isProtocolist?: boolean }>(
  items: readonly T[],
): T[] {
  return [
    ...items.filter((x) => !x.isProtocolist),
    ...items.filter((x) => x.isProtocolist),
  ];
}
